import { render, staticRenderFns } from "./SelecionarBemPoliticaVendas.vue?vue&type=template&id=73a84814&scoped=true&"
import script from "./SelecionarBemPoliticaVendas.vue?vue&type=script&lang=js&"
export * from "./SelecionarBemPoliticaVendas.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarBemPoliticaVendas.vue?vue&type=style&index=0&id=73a84814&lang=scss&scoped=true&"
import style1 from "./SelecionarBemPoliticaVendas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a84814",
  null
  
)

export default component.exports